import React from 'react';
import {PropTypes} from 'prop-types';
import style from './style.scss';
import Product from 'components/partials/product';
import {Link} from 'react-router-dom';
import {ShowIf} from 'components/utils';
import {Categories} from 'api';

class ItemCategory extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      category: [],
      products: []
    };
  }

  componentDidMount() {
    if (this.props.category) {
      let params = {
        id: this.props.category.id,
        filter: {
          limit: this.props.itemsToShow
        }
      };
      if (this.props.businessId) {
        params.filter.where = {
          businessId: this.props.businessId
        };
      }
      params.filter = JSON.stringify(params.filter);
      Categories.actions.listFixProducts.request(params).then(response => {
        this.setState({products: response.data});
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.category.id !== nextProps.category.id) {
      let params = {
        id: nextProps.category.id,
        filter: {
          limit: this.props.itemsToShow
        }
      };
      if (nextProps.businessId) {
        params.filter.where = {
          businessId: nextProps.businessId
        };
      }
      params.filter = JSON.stringify(params.filter);
      Categories.actions.listFixProducts.request(params).then(response => {
        this.setState({products: response.data});
      });
    }
  }

  render() {
    if (this.state.products.length === 0) {
      return null;
    }
    return (
      <div className="item-category" id={this.props.category.id}>
        <div className="des-category">
          <div className='des-category-wrap-img'>
            <i className={this.props.category.largeIcon}></i>
          </div>
          <p className="des-category-name">{this.props.category.name}</p>
          <p className="view-more">
            <ShowIf condition={this.props.for === 'product'}>
              <Link to={`/list-products/${this.props.category.id}`} className="view-more-link">Xem thêm</Link>
            </ShowIf>
            <ShowIf condition={this.props.for === 'business'}>
              <Link to={`/doanh-nghiep/${this.props.businessSlug}?category=${this.props.category.id}`} className="view-more-link">Xem thêm</Link>
            </ShowIf>
          </p>
        </div>
        {
          this.state.products.map((item, i) => {
            return (
              <div className='product-wrap' key={i}>
                <Product enableAddProduct={true} {...item}/>
              </div>
            );
          })
        }
      </div>
    );
  }
}

ItemCategory.propTypes = {
  itemsToShow: PropTypes.number,
  category: PropTypes.array,
  businessId: PropTypes.string,
  for: PropTypes.string
};

ItemCategory.defaultProps = {
  itemsToShow: 3
};

export default ItemCategory;



// WEBPACK FOOTER //
// ./components/partials/item-category/ItemCategory.jsx